import { GenIcon } from 'react-icons'

const CmPromotion = GenIcon({
  tag: 'svg',
  attr: { viewBox: '0 0 12 10' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M7.91211 0.734375L10.6406 3.50586C11.7793 4.64453 11.7793 6.4707 10.6406 7.60938L8.23438 10.0371C8.04102 10.252 7.71875 10.252 7.50391 10.0586C7.31055 9.84375 7.31055 9.52148 7.50391 9.32812L9.91016 6.87891C10.6406 6.14844 10.6406 4.9668 9.91016 4.23633L7.16016 1.44336C6.9668 1.25 6.9668 0.927734 7.18164 0.712891C7.375 0.519531 7.69727 0.519531 7.91211 0.734375ZM0.5 4.81641V1.59375C0.5 1.03516 0.951172 0.5625 1.53125 0.5625H4.73242C5.09766 0.5625 5.44141 0.712891 5.69922 0.970703L9.30859 4.58008C9.8457 5.11719 9.8457 5.99805 9.30859 6.53516L6.45117 9.39258C5.91406 9.92969 5.0332 9.92969 4.49609 9.39258L0.886719 5.7832C0.628906 5.52539 0.5 5.18164 0.5 4.81641ZM3.59375 2.96875C3.59375 2.60352 3.27148 2.28125 2.90625 2.28125C2.51953 2.28125 2.21875 2.60352 2.21875 2.96875C2.21875 3.35547 2.51953 3.65625 2.90625 3.65625C3.27148 3.65625 3.59375 3.35547 3.59375 2.96875Z'
      },
      child: []
    }
  ]
})

export default CmPromotion
